export const getImageCard = (mark) => {
    switch(mark) {
        case "1":
            return "/images/visa@3x.png";
        case "2":
            return "/images/mastercard@3x.png";
        case "3":
            return "/images/amex@3x.png";
        case "4":
            return "/images/carnet.png";
        case "999":
            return "/images/claroPay.png";
        case "996":
            return "/images/adelanto.png";
        case "997":
            return "/images/tarjetaClaropayCredito.png";
    }
}

export const getValueFromReference = (reference, amountData) => {
    
    let  amount = reference.substring(
        amountData.positionSubtractInitial, 
        amountData.positionSubtractFinal + 1 
    );

    if(amount === "" || isNaN(amount)){
        amount = 0;
    }else{
        if(amountData.denomination === "centavos"){
            amount = amount / 100;
        } else if(amountData.denomination === "pesos"){
            amount = parseFloat(amount);
        }
    }
    return amount;
    
}

export const handleValidation = (value, pattern) => {
   
    if (!pattern) return true;
    //console.log(typeof pattern);

    // string pattern, one validation rule
    if (typeof pattern === 'string') {
        //console.log(value);
        //console.log(pattern, "pat");
      const condition = new RegExp(pattern, 'i');
      let result = condition.test(value)
      return result;
    }
    // array patterns, multiple validation rules
    if (typeof pattern === 'object') {
      const conditions = pattern.map(rule => new RegExp(rule, 'g'));
      return conditions.map(condition => condition.test(value));
    }
}

export const validationStyles = (valid, isContainerTelcel, isClaroPartner) => {
   
    if(valid === undefined || valid === true){
        return {
            validInvalidAmountColor: '#000000',
            validInvalidColor: isContainerTelcel && !isClaroPartner ? '#222222' : '#323232',
            borderValidInvalidColor: isContainerTelcel && !isClaroPartner ? '1px solid #bac9d8' : '1px solid #26012024'
        }

    } else {
        return {
            validInvalidAmountColor:  'red',
            validInvalidColor:  'red',
            borderValidInvalidColor:  '1px solid red'
        }
    }
}